import React from 'react'
import moment from 'moment'
import './style.scss'

class AppFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__bottom">
          <div className="row">
            <div className="col-sm-6"></div>
            <div className="col-sm-6 col-sm-offset-6">
              <div className="footer__copyright">
                <span>
                  ® {moment().format('YYYY')}{' '}
                  PlugBoleto
                  <br />
                  Todos os direitos reservados
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppFooter
